import React, { useState, useEffect } from "react";
import { BaseButtons } from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";
import SelectAgentPopUp from "./components/select-agent-pop-up/SelectAgentPopUp";

const Team = ({
  companyServiceArray,
  setCompanyServicesArray,
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [admin1, setAdmin1] = useState(null);
  const [admin2, setAdmin2] = useState(null);
  const [finesTeamLeader, setFinesTeamLeader] = useState(null);
  const [liscensingTeamLeader, setLiscensingTeamLeader] = useState(null);
  const [salesTeamLeader, setSalesTeamLeader] = useState(null);
  const [valuationTeamLeader, setValuationTeamLeader] = useState(null);
  const [sparesTeamLeader, setSparesTeamLeader] = useState(null);
  const [autoFitmentTeamLeader, setAutoFitmentTeamLeader] = useState(null);
  const [towingTeamLeader, setTowingTeamLeader] = useState(null);
  const [servicesTeamLeader, setServicesTeamLeader] = useState(null);

  const [selectedTeamMemberData, setSelectedTeamMemberData] = useState(null);
  const [teamMemberType, setTeamMemberType] = useState("");

  const [agentsArray, setAgentsArray] = useState(null);

  const [selectTeamMemberPopUp, setSelectTeamMemberPopUp] = useState(false);

  const AssisgnTeamLeader = ({ agent }) => {
    if (teamMemberType === "fines") {
      setFinesTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    } else if (teamMemberType === "licensing") {
      setLiscensingTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    } else if (teamMemberType === "sales") {
      setSalesTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    } else if (teamMemberType === "valuation") {
      setValuationTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    } else if (teamMemberType === "auto-fitment") {
      setAutoFitmentTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    } else if (teamMemberType === "services") {
      setServicesTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    } else if (teamMemberType === "spares") {
      setSparesTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    } else if (teamMemberType === "towing") {
      setTowingTeamLeader({
        agentId: agent._id,
        name: agent.firstName + " " + agent.lastName,
      });
    }
  };
  const getCompanyAgents = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/getAllAgentsForAgency",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.userId,
            companyId: auth.companyId,
            team: teamMemberType,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setAgentsArray(respnseData.agentUsers);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage(respnseData.success);
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(
        "No network, contact support if you have a data connectin and are still unable to connect"
      );
      setToastPop(true);
      console.log("error", err);
    }
  };

  const UpdateCompanyData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/agency/agencyAdminUpdateData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.userId,
            companyId: auth.companyId,
            documentId: companyInformation._id,

            // teamMembers: [
            //   {
            //     admin1: {
            //       name: admin1.name,
            //       agentId: admin1.agentId,
            //     },
            //     admin2: {
            //       name: admin2.name || "none",
            //       agentId: admin2.agentId || "none",
            //     },

            //     finesTeamLeader: {
            //       name: finesTeamLeader.name || "none",
            //       agentId: finesTeamLeader.agentId || "none",
            //     },
            //     liscensingTeamLeader: {
            //       name: liscensingTeamLeader.name || "none",
            //       agentId: liscensingTeamLeader.agentId || "none",
            //     },
            //     valuationTeamLeader: {
            //       name: valuationTeamLeader.name || "none",
            //       agentId: valuationTeamLeader.agentId || "none",
            //     },
            //     salesTeamLeader: {
            //       name: salesTeamLeader.name || "none",
            //       agentId: salesTeamLeader.agentId || "none",
            //     },
            //     sparesTeamLeader: {
            //       name: sparesTeamLeader.name || "none",
            //       agentId: sparesTeamLeader.agentId || "none",
            //     },
            //     autoFitmentTeamLeader: {
            //       name: autoFitmentTeamLeader.name || "none",
            //       agentId: autoFitmentTeamLeader.agentId || "none",
            //     },
            //     servicesTeamLeader: {
            //       name: servicesTeamLeader.name || "none",
            //       agentId: servicesTeamLeader.agentId || "none",
            //     },
            //     towingTeamLeader: {
            //       name: towingTeamLeader.name || "none",
            //       agentId: towingTeamLeader.agentId || "none",
            //     },
            //   },
            // ],
            teamMembers: {
              admin1: {
                agentId: admin1.agentId,
                name: admin1.name,
              },
              admin2: {
                agentId: admin2.agentId !== "" ? admin2.agentId : "none",
                name: admin2.name !== "" ? admin2.name : "none",
              },
              finesTeamLeader: {
                agentId:
                  finesTeamLeader.agentId !== ""
                    ? finesTeamLeader.agentId
                    : "none",
                name:
                  finesTeamLeader.name !== "" ? finesTeamLeader.name : "none",
              },
              liscensingTeamLeader: {
                agentId:
                  liscensingTeamLeader.agentId !== ""
                    ? liscensingTeamLeader.agentId
                    : "none",
                name:
                  liscensingTeamLeader.name !== ""
                    ? liscensingTeamLeader.name
                    : "none",
              },
              servicesTeamLeader: {
                agentId:
                  servicesTeamLeader.agentId !== ""
                    ? servicesTeamLeader.agentId
                    : "none",
                name:
                  servicesTeamLeader.name !== ""
                    ? servicesTeamLeader.name
                    : "none",
              },
              salesTeamLeader: {
                agentId:
                  salesTeamLeader.agentId !== ""
                    ? salesTeamLeader.agentId
                    : "none",
                name:
                  salesTeamLeader.name !== "" ? salesTeamLeader.name : "none",
              },
              vaulationTeamLeader: {
                agentId:
                  valuationTeamLeader.agentId !== ""
                    ? valuationTeamLeader.agentId
                    : "none",
                name:
                  valuationTeamLeader.name !== ""
                    ? valuationTeamLeader.name
                    : "none",
              },
              autoFitmentTeamLeader: {
                agentId:
                  autoFitmentTeamLeader.agentId !== ""
                    ? autoFitmentTeamLeader.agentId
                    : "none",
                name:
                  autoFitmentTeamLeader.name !== ""
                    ? autoFitmentTeamLeader.name
                    : "none",
              },
              towingTeamLeader: {
                agentId:
                  towingTeamLeader.agentId !== ""
                    ? towingTeamLeader.agentId
                    : "none",
                name:
                  towingTeamLeader.name !== "" ? towingTeamLeader.name : "none",
              },
              sparesTeamLeader: {
                agentId:
                  sparesTeamLeader.agentId !== ""
                    ? sparesTeamLeader.agentId
                    : "none",
                name:
                  sparesTeamLeader.name !== "" ? sparesTeamLeader.name : "none",
              },
            },
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setMessage(respnseData.success);
        setLoading(false);
        setRefresh(refresh ? false : true);
        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage(respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      setLoading(false);
      setMessage(err);
      setPopUpTitle("FAILED");
      setToastPop(true);
    }
  };
  useEffect(() => {
    if (companyInformation) {
      setAdmin1(companyInformation.teamMembers[0].admin1);
      setAdmin2(companyInformation.teamMembers[0].admin2);
      setFinesTeamLeader(companyInformation.teamMembers[0].finesTeamLeader);
      setLiscensingTeamLeader(
        companyInformation.teamMembers[0].liscensingTeamLeader
      );
      setSalesTeamLeader(companyInformation.teamMembers[0].salesTeamLeader);
      setValuationTeamLeader(
        companyInformation.teamMembers[0].vaulationTeamLeader
      );
      setSparesTeamLeader(companyInformation.teamMembers[0].sparesTeamLeader);
      setAutoFitmentTeamLeader(
        companyInformation.teamMembers[0].autoFitmentTeamLeader
      );
      setTowingTeamLeader(companyInformation.teamMembers[0].towingTeamLeader);
      setServicesTeamLeader(
        companyInformation.teamMembers[0].servicesTeamLeader
      );
    }
  }, [companyInformation]);

  useEffect(() => {
    if (teamMemberType !== "") {
      getCompanyAgents();
    }
  }, [teamMemberType]);
  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "row" }}>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "100%",
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "95%", fontWeight: "bold", fontSize: 18 }}>
            ADMIN USERS
          </div>
        </div>
        {/* this the admin users */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: colors.white,
              borderStyle: "solid",
              borderWidth: 3,
              borderColor: colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              ADMIN 1
            </div>
            <div style={{ width: "90%", textAlign: "center" }}>
              {admin1 ? admin1.name.toLocaleUpperCase() : "loading"}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: admin2
                ? admin2.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: admin2
                ? admin2.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: admin2
                ? admin2.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: admin2
                ? admin2.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: admin2
                ? admin2.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              //   marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              ADMIN 2
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: admin2
                  ? admin2.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {admin2 ? (
                admin2.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("admin 2");
                    }}
                  />
                ) : (
                  admin2.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            marginTop: 20,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "95%", fontWeight: "bold", fontSize: 18 }}>
            TEAM LEADERS
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: finesTeamLeader
                ? finesTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: finesTeamLeader
                ? finesTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: finesTeamLeader
                ? finesTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: finesTeamLeader
                ? finesTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: finesTeamLeader
                ? finesTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              FINES TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: finesTeamLeader
                  ? finesTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {finesTeamLeader ? (
                finesTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("fines");
                    }}
                  />
                ) : (
                  finesTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: liscensingTeamLeader
                ? liscensingTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: liscensingTeamLeader
                ? liscensingTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: liscensingTeamLeader
                ? liscensingTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: liscensingTeamLeader
                ? liscensingTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: liscensingTeamLeader
                ? liscensingTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              LICENSING TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: liscensingTeamLeader
                  ? liscensingTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {liscensingTeamLeader ? (
                liscensingTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("licensing");
                    }}
                  />
                ) : (
                  liscensingTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: valuationTeamLeader
                ? valuationTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: valuationTeamLeader
                ? valuationTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: valuationTeamLeader
                ? valuationTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: valuationTeamLeader
                ? valuationTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: valuationTeamLeader
                ? valuationTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              VALUATION TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: valuationTeamLeader
                  ? valuationTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {valuationTeamLeader ? (
                valuationTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("valuation");
                    }}
                  />
                ) : (
                  valuationTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: salesTeamLeader
                ? salesTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: salesTeamLeader
                ? salesTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: salesTeamLeader
                ? salesTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: salesTeamLeader
                ? salesTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: salesTeamLeader
                ? salesTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              SALES TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: salesTeamLeader
                  ? salesTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {salesTeamLeader ? (
                salesTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("sales");
                    }}
                  />
                ) : (
                  salesTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: autoFitmentTeamLeader
                ? autoFitmentTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: autoFitmentTeamLeader
                ? autoFitmentTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: autoFitmentTeamLeader
                ? autoFitmentTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: autoFitmentTeamLeader
                ? autoFitmentTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: autoFitmentTeamLeader
                ? autoFitmentTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              AUTO-FITMENT TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: autoFitmentTeamLeader
                  ? autoFitmentTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {autoFitmentTeamLeader ? (
                autoFitmentTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("auto-fitment");
                    }}
                  />
                ) : (
                  autoFitmentTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: servicesTeamLeader
                ? servicesTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: servicesTeamLeader
                ? servicesTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: servicesTeamLeader
                ? servicesTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: servicesTeamLeader
                ? servicesTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: servicesTeamLeader
                ? servicesTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              SERVICES TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: servicesTeamLeader
                  ? servicesTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {servicesTeamLeader ? (
                servicesTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("services");
                    }}
                  />
                ) : (
                  servicesTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: sparesTeamLeader
                ? sparesTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: sparesTeamLeader
                ? sparesTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: sparesTeamLeader
                ? sparesTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: sparesTeamLeader
                ? sparesTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: sparesTeamLeader
                ? sparesTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              SPARE TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: sparesTeamLeader
                  ? sparesTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {sparesTeamLeader ? (
                sparesTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("spares");
                    }}
                  />
                ) : (
                  sparesTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minHeight: 90,
              width: 250,
              backgroundColor: towingTeamLeader
                ? towingTeamLeader.name === "none"
                  ? null
                  : colors.white
                : colors.white,
              borderStyle: towingTeamLeader
                ? towingTeamLeader.name === "none"
                  ? "none"
                  : "solid"
                : "solid",
              borderWidth: 3,
              borderColor: towingTeamLeader
                ? towingTeamLeader.name === "none"
                  ? null
                  : colors.secondaryDarkBlue
                : colors.secondaryDarkBlue,
              borderRadius: 8,
              justifyContent: "flex-start",
              alignItems: "center",
              WebkitBoxShadow: towingTeamLeader
                ? towingTeamLeader.name === "none"
                  ? null
                  : "-5px 5px 15px -1px #00000070"
                : "-5px 5px 15px -1px #00000070",
              overflow: towingTeamLeader
                ? towingTeamLeader.name === "none"
                  ? null
                  : "hidden"
                : "hidden",
              marginLeft: 20,
            }}
          >
            <div
              style={{
                width: "90%",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              TOWING TEAM LEADER
            </div>
            <div
              style={{
                textAlign: "center",
                width: "90%",
                display: "flex",
                justifyContent: towingTeamLeader
                  ? towingTeamLeader.name === "none"
                    ? "center"
                    : "flex-start"
                  : "flex-start",
              }}
            >
              {towingTeamLeader ? (
                towingTeamLeader.name === "none" ? (
                  <BaseButtons
                    label={"ADD "}
                    borderRadius={8}
                    backgroundColor={colors.secondaryDarkBlue}
                    width={150}
                    onClick={() => {
                      setSelectTeamMemberPopUp(true);
                      setTeamMemberType("towing");
                    }}
                  />
                ) : (
                  towingTeamLeader.name.toLocaleUpperCase()
                )
              ) : (
                "loading"
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: "absolute", top: 10, right: 10 }}>
        <BaseButtons
          label={"UPDATE"}
          backgroundColor={colors.secondaryDarkBlue}
          borderRadius={8}
          width={150}
          onClick={() => UpdateCompanyData()}
        />
      </div>
      <SelectAgentPopUp
        display={selectTeamMemberPopUp && agentsArray ? true : false}
        setSelectTeamMemberPopUp={setSelectTeamMemberPopUp}
        teamMemberType={teamMemberType}
        setTeamMemberType={setTeamMemberType}
        agentsArray={agentsArray}
        setAgentsArray={setAgentsArray}
        AssisgnTeamLeader={AssisgnTeamLeader}
      />
    </div>
  );
};

export default Team;
